import React from 'react';
import { calculateCartTotals } from '../../utils/medicineHelpers';

const CartSummary = ({
  cart,
  orderDeliveryCharge,
  handlingPackagingCharge,
  platformCharge,
  cartCashback,
  onUpdateDeliveryCharge,
  onUpdateHandlingPackagingCharge,
  onUpdatePlatformCharge,
  orderDeliveryChargeError,
  handlingPackagingChargeError,
  platformChargeError
}) => {
  const { totalMRP, totalAyushPay } = calculateCartTotals(
    cart,
    orderDeliveryCharge,
    handlingPackagingCharge,
    platformCharge
  );

  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      {/* Order-level Charges */}
      <div className="flex items-center gap-x-4 gap-y-6 flex-wrap mb-7">
        {/* Delivery Charge */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Delivery Charge (₹):</label>
          <div className="relative flex flex-col">
            <input
              type="number"
              value={orderDeliveryCharge === null || orderDeliveryCharge === undefined ? '' : orderDeliveryCharge}
              readOnly
              tabIndex={-1}
              title="Auto-calculated from cart value"
              className="w-24 px-3 py-1.5 border border-gray-200 rounded-md bg-gray-100 text-gray-600 cursor-not-allowed focus:outline-none"
            />
            <span className="absolute left-0 top-full mt-0.5 text-xs text-gray-500 whitespace-nowrap">Auto-calculated</span>
          </div>
        </div>
        {/* Handling & Packaging Charge */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Handling & Packaging Fee (₹):</label>
          <div className="relative flex flex-col">
            <input
              type="number"
              value={handlingPackagingCharge === null || handlingPackagingCharge === undefined ? '' : handlingPackagingCharge}
              onChange={(e) => onUpdateHandlingPackagingCharge(e.target.value)}
              onKeyDown={(e) => {
                // Prevent arrow keys from changing the value
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => {
                // Prevent scroll from changing the value
                e.target.blur();
              }}
              step="0.01"
              min="0"
              className={`w-24 px-3 py-1.5 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                handlingPackagingChargeError ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {handlingPackagingChargeError && (
              <span className="absolute left-0 top-full mt-0.5 text-xs text-red-600 whitespace-nowrap">{handlingPackagingChargeError}</span>
            )}
          </div>
        </div>
        {/* Platform Charge */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Platform Fee (₹):</label>
          <div className="relative flex flex-col">
            <input
              type="number"
              value={platformCharge === null || platformCharge === undefined ? '' : platformCharge}
              onChange={(e) => onUpdatePlatformCharge(e.target.value)}
              onKeyDown={(e) => {
                // Prevent arrow keys from changing the value
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => {
                // Prevent scroll from changing the value
                e.target.blur();
              }}
              step="0.01"
              min="0"
              className={`w-24 px-3 py-1.5 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                platformChargeError ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {platformChargeError && (
              <span className="absolute left-0 top-full mt-0.5 text-xs text-red-600 whitespace-nowrap">{platformChargeError}</span>
            )}
          </div>
        </div>
      </div>
      {/* Totals */}
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-lg font-semibold text-gray-900">Total MRP:</span>
          <span className="text-lg font-semibold text-gray-900">₹{totalMRP.toFixed(2)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-lg font-semibold text-blue-600">Total AyushPay:</span>
          <span className="text-lg font-semibold text-blue-600">₹{totalAyushPay.toFixed(2)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-lg font-semibold text-green-600">Cashback:</span>
          <span className="text-lg font-semibold text-green-600">₹{(cartCashback || 0).toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;

